'use client';
import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../../../stitches.config.js';
import { SelectTrigger, Value, SelectIcon } from '@radix-ui/react-select';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import { selectColorVariants } from '../styles.js';

const Trigger = (_a) => {
    var { placeholder = 'Select a category', error = false } = _a, props = __rest(_a, ["placeholder", "error"]);
    return (
    // @ts-expect-error
    React.createElement(StyledTrigger, Object.assign({}, props, { error: error, "aria-label": "select-trigger" }),
        React.createElement(Value, { placeholder: placeholder }),
        React.createElement(SelectIcon, null,
            React.createElement(ChevronDownIcon, null))));
};
const StyledTrigger = styled(SelectTrigger, {
    all: 'unset',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    padding: '0 15px',
    fontSize: 13,
    lineHeight: 1,
    height: 35,
    gap: 5,
    backgroundColor: '$loContrast',
    boxShadow: '$border',
    color: '$primary12',
    // boxShadow: `0px 0px 3px $colors$gray8`,
    // boxShadow: '$boxShadow',
    '&:hover': { backgroundColor: '$gray3' },
    '&:focus': { boxShadow: `$focus` },
    '&[data-placeholder]': { color: '$gray12' },
    gridArea: 'category',
    border: '$boxShadow',
    variants: Object.assign(Object.assign({}, selectColorVariants), { border: {
            thin5: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay5',
            },
            thin6: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay6',
            },
            thin7: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay7',
            },
            thin8: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay8',
            },
            thin9: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay9',
            },
            thin10: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay10',
            },
            thin11: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay11',
            },
            thin12: {
                border: '0 0 0 calc(1px / var(--scale-x, 1)) $colors$overlay12',
            },
        } }),
    defaultVariants: {
        color: 'loContrast'
    }
});

export { Trigger as default };
